/*************************************************************
 * Dear Programmer
 *
 * When I wrote this code, only God and I knew how it worked.
 * Now, only God knows it!!!
 *
 * Therefore, if you are trying to optimize this routine and
 * it fails (most surely), please increase this counter as a
 * warning for the next person:
 *
 * total_hours_wasted_here = 105
 *
 *************************************************************/

import React from "react";
import LoginByEmail from "../components/LoginByEmail";
import "../App.css";
function RoleLogin() {
  return <LoginByEmail />;
}

export default RoleLogin;
